/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'

import { apiCall } from './api'

export const SEND_SCHEDULE_START_EVENT = createAsyncAction(
  'SEND_SCHEDULE_START_EVENT'
)
export const sendScheduleStartEvent = (campaignID: number | string) =>
  apiCall({
    method: 'post',
    endpoint: `/campaign/schedule-start-event/${campaignID}`,
    query: {},
    types: SEND_SCHEDULE_START_EVENT,
  })

export const SEND_PAYMENT_START_EVENT = createAsyncAction(
  'SEND_PAYMENT_START_EVENT'
)
export const sendPaymentStartEvent = (
  campaignID: number | string,
  transaction: { price: number; start_date: string },
  url: string
) =>
  apiCall({
    method: 'post',
    endpoint: `/campaign/payment-start-event/${campaignID}`,
    query: {
      transaction,
      url,
    },
    types: SEND_PAYMENT_START_EVENT,
  })

export const SEND_PAYMENT_COMPLETED_EVENT = createAsyncAction(
  'SEND_PAYMENT_COMPLETED_EVENT'
)
export const sendPaymentCompletedEvent = (
  campaignID: number | string,
  transaction: { price: number; start_date?: string | Date },
  url: string
) =>
  apiCall({
    method: 'post',
    endpoint: `/campaign/payment-completed-event/${campaignID}`,
    query: {
      transaction,
      url,
    },
    types: SEND_PAYMENT_COMPLETED_EVENT,
  })

export const SEND_PAYMENT_INFO_EVENT = createAsyncAction(
  'SEND_PAYMENT_INFO_EVENT'
)
export const sendPaymentInfoEvent = (
  campaignID: number | string,
  url: string
) =>
  apiCall({
    method: 'post',
    endpoint: `/campaign/payment-info/${campaignID}`,
    query: {
      url,
    },
    types: SEND_PAYMENT_INFO_EVENT,
  })
